"use strict";
/**
 * Record a Handshake **withdrawal payout** in Xero as a **bank transfer**:
 * Handshake clearing/wallet bank → business operating bank (not spend-money + expense).
 *
 * ## Trigger
 * After a successful provider payout (`syncWithdrawalPayoutToXeroIfReady` from wallets).
 *
 * ## Mappings
 * - **From**: {@link AccountingAccountMappingSlot.ACCOUNTS_RECEIVABLE} — same clearing BANK used for escrow payment allocation.
 * - **To**: {@link AccountingAccountMappingSlot.WITHDRAWAL_DESTINATION_BANK} — real operating bank where funds arrive.
 *
 * ## Idempotency key
 * `${ACCOUNTING_WITHDRAWAL_SYNC_IDEMPOTENCY_PREFIX}${payoutId}`
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNTING_WITHDRAWAL_SYNC_IDEMPOTENCY_PREFIX = exports.ACCOUNTING_SYNC_OPERATION_CREATE_XERO_WITHDRAWAL_BANK_TRANSFER = exports.ACCOUNTING_SYNC_OPERATION_CREATE_WITHDRAWAL_BANK_TRANSFER = void 0;
exports.isWithdrawalTransferAccountingSyncOp = isWithdrawalTransferAccountingSyncOp;
/** Provider-neutral withdrawal bank-transfer sync operation (preferred for new writes). */
exports.ACCOUNTING_SYNC_OPERATION_CREATE_WITHDRAWAL_BANK_TRANSFER = "CREATE_WITHDRAWAL_BANK_TRANSFER";
/**
 * Legacy Xero-branded operation string — still present in existing idempotency rows.
 * Prefer {@link ACCOUNTING_SYNC_OPERATION_CREATE_WITHDRAWAL_BANK_TRANSFER} for new writes.
 */
exports.ACCOUNTING_SYNC_OPERATION_CREATE_XERO_WITHDRAWAL_BANK_TRANSFER = "CREATE_XERO_WITHDRAWAL_BANK_TRANSFER";
/** True when `operation` is the neutral or legacy Xero withdrawal-transfer op. */
function isWithdrawalTransferAccountingSyncOp(operation) {
    return (operation === exports.ACCOUNTING_SYNC_OPERATION_CREATE_WITHDRAWAL_BANK_TRANSFER ||
        operation === exports.ACCOUNTING_SYNC_OPERATION_CREATE_XERO_WITHDRAWAL_BANK_TRANSFER);
}
exports.ACCOUNTING_WITHDRAWAL_SYNC_IDEMPOTENCY_PREFIX = "withdrawal_payout:";
